<template>
    <el-dialog :title="personnelLabelId ? '编辑人员标签' : '新增人员标签'" :visible.sync="personnelLabelDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="loading">
            <el-form-item label="标签名称" prop="label">
                <el-input v-model="formData.label" :maxlength="20" placeholder="请输入标签名称"></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="desc" class="form-item-textarea">
                <el-input :rows="3" :maxlength="100" placeholder="请输入标签描述" show-word-limit type="textarea" v-model="formData.desc"></el-input>
            </el-form-item>
            <el-form-item label="关联人员" prop="userIds">
                <el-select  placeholder="请选择人员，可输入人员姓名搜索" v-model="formData.userIds" :remote-method="getUserList" multiple filterable remote reserve-keyword>
                    <el-option v-for="userItem in userList" :key="userItem.uid" :value="userItem.uid" :label="userItem.name"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary"  :disabled="btnDisabled" @click.stop="handleDialogConfirm">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {PersonTagEdit,PersonTagAdd,GetUserList,PersonTagDetail} from "@/api";
export default {
    name: "personnelLabelOperate",
    props: {
        personnelLabelDialog: {
            type: Boolean,
            default: false
        },
        personnelLabelId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading:false,
            btnDisabled:false,
            formData: {
                label: "",
                desc: "",
                userIds: []
            },
            formRules: {
                label: [
                    {required: true, message: "请输入必填项"}
                ]
            },
            userList: []
        }
    },
    created() {
        this.getUserList()
        if(this.personnelLabelId) {
            this.getPersonTagDetail()
        }
    },
    methods: {
        getPersonTagDetail(){
            let postData = {
                id:this.personnelLabelId
            }
            this.loading = true
            PersonTagDetail(postData).then(res => {
                if (res.code === 200) {
                    let {name,describe,users} = res.data
                    this.formData.label = name
                    this.formData.desc = describe
                    if(users && users.length>0){
                        this.formData.userIds = users.map((map)=> {return map.uid})
                    }
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },

        handleDialogClose() {
            this.$emit("update:personnelLabelDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid=> {
                if(valid) {
                    this.btnDisabled = true
                    let postData = {
                        name: this.formData.label,
                        describe: this.formData.desc,
                        user_ids:this.formData.userIds,
                    }
                    if(this.personnelLabelId){
                        postData.id = this.personnelLabelId
                        PersonTagEdit(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false
                                        this.$emit('success')
                                        this.handleDialogClose()
                                    }
                                })
                            } else {
                                this.btnDisabled = false
                                // this.$message.error(res.message)
                            }
                        })
                    }else{
                        PersonTagAdd(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {
                                        this.btnDisabled = false
                                        this.$emit('success')
                                        this.handleDialogClose()
                                    }
                                })
                            } else {
                                this.btnDisabled = false
                                // this.$message.error(res.message)
                            }
                        })
                    }

                }
            })
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
    }
}
</script>
